<template>
	<div class="wrap">

		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/shoye' }">首页设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加视频</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="80px" :model="formData">
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="权重">
					<el-input type="number" v-model="formData.weights" style="width: 100px;"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="视频封面">
					<!-- <el-input v-model="formData.picUrl"></el-input> --><!-- v-model="formLabelAlign.name" -->
					<el-upload class="upload-demo" :action="uploadUrl" :limit="1" :file-list="fileList" list-type="picture" :on-remove="onRemove"
					 :on-success="onSuccess">
						<el-button size="small" type="primary">点击上传视频封面图</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="视频标题">
					<el-input v-model="formData.title"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="视频">
					<!-- <el-input v-model="formData.picUrl"></el-input> --><!-- v-model="formLabelAlign.name" -->
					<el-upload class="upload-demo" list-type="picture" :action="uploadUrl" :limit="1" :on-remove="onRemove2"
					 :on-success="onSuccess2">
						<el-button size="small" type="primary">点击上传视频</el-button>
					</el-upload><!-- v-model="formLabelAlign.type" -->
				</el-form-item>
			</el-form>

			<!-- 富文本编辑器 -->
			<!-- <quill-editor v-model="quillData"></quill-editor> -->
			<!-- 添加商品 -->
			<el-button type="success" class="submitBtn" @click="submitFun">立即提交</el-button>
		</el-card>

	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo',
				fileList: [],
				fileList2:[],
				fileList3:[],
				id: '',
				detailData:{},
				formData:{
					picUrl:'',
					title:'',
					weights:""
				},
				
			}
		},
		created() {
			
		},
		methods: {
			onRemove(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList2 = [];
			},
			onSuccess(res) {
				console.log('res=' + res)
				this.fileList2.push(res)
			},
			onRemove2(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList3 = []
			},
			onSuccess2(res) {
				console.log('res=' + res)
				this.fileList3.push(res)
			},
			async submitFun(){
				/* 视频新增/v1/official/manag/video/add post请求 参数 String title（标题），
				String videoLink（视频），Integer weights（权重），String coverPicture（封面图） */
				var obj={}
				obj['weights'] = +this.formData.weights
				obj['videoLink'] = this.fileList3.join(',')
				obj['coverPicture'] = this.fileList2.join(',')
				obj['title'] = this.formData.title
				console.log(JSON.stringify(obj))
				if(obj.title=='' || obj.videoLink=='' || obj.coverPicture == '' || obj.weights == ''){
					return this.$message.error('请填写必要的参数！')
				}
				var res = await this.$http.post('/v1/official/manag/video/add',{
					request:obj
				})
				console.log(JSON.stringify(res))
				if(res.data.code == 0){
					this.$message.success('添加成功')
				}else{
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
.el-card{
	/* width: 1000px; */
}
.submitBtn{
	margin: 0 auto;
	margin-top:20px ;
	margin-left: 80px;
}
</style>
